<template>
  <span>
    <transition name="fade">
      <!--Content-->
      <div
        class="bcc-popover"
        ref="popover"
        :style="{width: width + 'px', 'z-index': zIndex}"
        v-show="!disabled && visible">
        <slot>{{content}}</slot>
      </div>
    </transition>
    <!--Trigger-->
    <slot name="reference"></slot>
  </span>
</template>

<script>
import Popper from 'popper.js'
import { on, off, elementContains } from './utils'
export default {
  name: 'BccPopover',
  props: {
    placement: {
      type: String,
      default: 'top',
      validator (val) {
        return ['top', 'top-start', 'top-end', 'left', 'right', 'bottom', 'bottom-start', 'bottom-end'].indexOf(val) > -1
      }
    },
    trigger: {
      type: String,
      default: 'click',
      validator (trigger) {
        return ['click', 'hover', 'focus'].indexOf(trigger) > -1
      }
    },
    content: String,
    showArrow: {
      type: Boolean,
      default: true
    },
    width: [String, Number],
    zIndex: Number,
    disabled: Boolean,
    value: Boolean,
    options: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      visible: false,
      popperJS: null,
      reference: null,
      popperOptions: {
        computeStyle: {
          gpuAcceleration: false
        }
      },
      appendedArrow: false
    }
  },
  watch: {
    visible (val) {
      if (val) {
        if (this.popperJS) {
          this.popperJS.enableEventListeners()
        }
        this.updatePopper()
      } else {
        if (this.popperJS) {
          this.popperJS.disableEventListeners()
        }
      }
      this.$emit('input', val)
      val ? this.$emit('show') : this.$emit('hide')
    },
    value: {
      immediate: true,
      handler (val) {
        this.visible = val
      }
    }
  },
  created () {
    let popperOptions = this.popperOptions
    let options = this.options
    popperOptions = Object.assign(popperOptions, options)
    if (options.computeStyle && options.computeStyle.hasOwnProperty('gpuAcceleration')) {
      popperOptions.computeStyle.gpuAcceleration = (options.computeStyle.gpuAcceleration.toString() === 'true' ||
        options.computeStyle.gpuAcceleration.toString() === 'false')
        ? options.computeStyle.gpuAcceleration : false
    } else {
      popperOptions.computeStyle.gpuAcceleration = false
    }
  },
  mounted () {
    this.reference = this.$slots.reference[0].elm
    this.popper = this.$refs.popover || this.$slots.default[0].elm
    switch (this.trigger) {
      case 'click':
        on(this.reference, 'click', this.toggle)
        on(document, 'click', this.handleDocumentClick)
        break
      case 'hover':
        on(this.reference, 'mouseover', this.onMouseOver)
        on(this.popper, 'mouseover', this.onMouseOver)
        on(this.reference, 'mouseout', this.onMouseOut)
        on(this.popper, 'mouseout', this.onMouseOut)
        break
      case 'focus':
        if (this.reference.querySelector('input, textarea')) {
          on(this.reference, 'focusin', this.show)
          on(this.reference, 'focusout', this.close)
        } else {
          on(this.reference, 'mousedown', this.show)
          on(this.reference, 'mouseup', this.close)
        }
        break
    }
  },
  methods: {
    toggle () {
      this.visible = !this.visible
    },
    show () {
      this.visible = true
    },
    close () {
      this.visible = false
    },
    onMouseOver () {
      clearTimeout(this._timer)
      this._timer = setTimeout(() => {
        this.show()
      }, 200)
    },
    onMouseOut () {
      clearTimeout(this._timer)
      this._timer = setTimeout(() => {
        this.close()
      }, 200)
    },
    createPopper () {
      if (!this.popper || !this.reference) {
        return
      }
      this.$nextTick(() => {
        if (this.showArrow) {
          this.appendArrow(this.popper)
        }
        this.popperOptions.placement = this.placement
        this.popperOptions.onCreate = () => {
          this.$nextTick(this.updatePopper)
        }
        this.popperJS = new Popper(this.reference, this.popper, this.popperOptions)
      })
    },
    updatePopper () {
      this.popperJS ? this.popperJS.scheduleUpdate() : this.createPopper()
    },
    handleDocumentClick (e) {
      if (!this.$el || !this.reference ||
        elementContains(this.$el, e.target) ||
        elementContains(this.reference, e.target) ||
        !this.popper || elementContains(this.popper, e.target)
      ) {
        return
      }
      this.visible = false
    },
    appendArrow (element) {
      if (this.appendedArrow) {
        return
      }
      this.appendedArrow = true
      const arrow = document.createElement('div')
      arrow.setAttribute('x-arrow', '')
      arrow.className = 'popper__arrow'
      element.appendChild(arrow)
    },
    destroy () {
      if (this.visible) {
        return
      }
      this.popperJS && this.popperJS.destroy()
      this.popperJS = null
    },
    destroyPopper () {
      off(this.reference, 'click', this.toggle)
      off(this.reference, 'mouseout', this.onMouseOut)
      off(this.reference, 'mouseover', this.onMouseOver)
      off(document, 'click', this.handleDocumentClick)
      off(this.reference, 'focusin', this.show)
      off(this.reference, 'focusout', this.close)
      off(this.reference, 'mousedown', this.show)
      off(this.reference, 'mouseup', this.close)
      this.visible = false
      this.destroy()
    }
  },
  destroyed () {
    this.destroyPopper()
  }
}
</script>
